import { Box, H1 } from "@adfenix/alexandria";

import Page from "components/Page";

export const TemporaryError = () => {
  return (
    <Page>
      <Box p="xl5">
        <H1>Temporary error!</H1>
        We are currently experiencing unplanned downtime due to a server
        malfunction. We will be back as soon as possible. To place orders,
        please log out and use your email links.
      </Box>
    </Page>
  );
};

export default TemporaryError;
